/*
* Use this implementation to fetch data from the server
* You can set rejectDebug = true in the console to test your error handling
*/

const client = (endpoint, {body, ...customConfig} = {}) => {
  const headers = {'Content-Type': 'application/json'}
  const config = {
    method: body ? 'POST' : 'GET',
    credentials: "same-origin", // has to be set in order to use cookies: https://github.com/github/fetch#sending-cookies
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  }

  if (body) {
    if (typeof body !== "object") throw new Error("Body muss ein Objekt sein");

    config.body = JSON.stringify(body)
  }

  const rejectDebug = window.rejectDebug || false;

  if (rejectDebug) {
    return Promise.reject("Rejecting for debugging");
  }

  return window
    .fetch(endpoint, config)
    .then(async response => {
      const data = await response.json()
      if (response.ok) {
        return data
      } else {
        return Promise.reject(data)
      }
    })
}

export default client;
